import { render, staticRenderFns } from "./drawer-search-staffs.vue?vue&type=template&id=5c3bb5ba&"
import script from "./drawer-search-staffs.vue?vue&type=script&lang=js&"
export * from "./drawer-search-staffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports